import { dialog, InfiniteScroll } from "../../../nq-component";
import BaseListPage from "../../../base/BaseListPage.js";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  getObjectUseCase,
  upsertUseCase,
} from "../../../usecases/object/index.js";
import { getCurrentUserUseCase } from "../../../usecases/user/index.js";
import withRouter from "../../../withRouter.js";
import DialogCreate from "../../../components/DialogCreate/index.js";
import AddButton from "../../../components/AddButton/index.js";
import CustomConfirmation from "../../../components/CustomConfirmation/index.js";
import CustomLoader from "../../../components/CustomLoader/index.js";
import Search from "../../../components/Search/index.js";
import CollapseDetails from "./components/CollapseDetails.js";
import ClientsListPagePresenter from "./ClientsListPagePresenter.js";
import ClientsTable from "./components/ClientsTable.js";
import DialogOptions from "./components/DialogOptions.js";
import InputFactory from "../../../components/InputFactory/index.js";
import PageHeader from "../../../components/PageHeader/index.js";
import SearchFilterCard from "../../../components/SearchFilterCard/index.js";
import CardWithHeader from "../../../components/CardWithHeader/index.js";

class ClientsListPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.state = {
      selected: [],
      objects: [],
      userObject: {},
    };

    this.presenter = new ClientsListPagePresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase(),
      getCurrentUserUseCase(),
      getObjectUseCase(),
    );
  }

  getCollectionName() {
    return "clients";
  }

  getParamsMonth() {
    return this.props.params.month;
  }

  getParamsYear() {
    return this.props.params.year;
  }

  getMonths() {
    return this.presenter.getMonths();
  }

  getClientId() {
    return this.props.params.clientId;
  }

  onSubmitModal(collection, object) {
    this.presenter.onSubmitModal(collection, object);
  }

  createModal(collection, field, placeholder) {
    dialog.fire({
      html: (
        <DialogCreate
          placeholder={placeholder}
          field={field}
          collection={collection}
          onSubmitModal={this.onSubmitModal.bind(this)}
        />
      ),
      footer: false,
    });
  }

  onSubmit(object) {
    this.presenter.onSubmit(object);
  }

  onDeleteModal(index) {
    dialog.fire({
      html: <CustomConfirmation />,
      footer: false,
    });
  }

  onCloseDialog() {
    dialog.close();
  }

  onClickSole() {
    dialog.close();
    const { userObject } = this.state;

    const isAdmin = this.isAdmin();
    if (isAdmin && userObject?.id) {
      return this.navigateTo(`/clients/form-client/sole/${userObject?.id}`);
    } else {
      return this.navigateTo(`/clients/form-input/sole`);
    }
  }

  onClickCorp() {
    dialog.close();
    const { userObject } = this.state;

    const isAdmin = this.isAdmin();
    if (isAdmin && userObject?.id) {
      return this.navigateTo(`/clients/form-client/corp/${userObject?.id}`);
    } else {
      return this.navigateTo(`/clients/form-input/corp`);
    }
  }

  // onClickAdd() {
  //   dialog.fire({
  //     html: (
  //       <DialogOptions
  //         onClickOption1={this.onClickSole.bind(this)}
  //         onClickOption2={this.onClickCorp.bind(this)}
  //       />
  //     ),
  //     footer: false,
  //   });
  // }

  onClickAdd() {
    this.navigateTo("/clients/form-input");
  }

  onEdit(object) {
    this.navigateTo(`/clients/form/${object?.id}`);
  }

  onSetSelectedStatus(field, value) {
    const selected = this.getSelected();
    if (!selected?.length) return;
    const action = value ? "activate" : "deactivate";
    const message =
      selected.length === 1
        ? `Are you sure you want to ${action} this item?`
        : `Are you sure you want to ${action} ${selected.length} selected items?`;
    const title = value ? "Activate selected" : "Deactivate selected";
    this.showConfirmDialog(message, title, "Confirm", "Cancel")
      .then(() => this.presenter.updateBooleanFieldBulk(selected, field, value))
      .catch(() => {});
  }

  onViewEmployee(id) {
    this.navigateTo(`/employees/${id}`);
  }

  onCollapse(index, object) {
    const roles = this.getCurrentUser().roles;
    const { userObject } = this.state;
    return (
      <CollapseDetails object={object} roles={roles} userObject={userObject} />
    );
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const schemas = this.getSchemas();
    const user = this.getCurrentUser();
    const isAdmin = this.isAdmin();

    if (!schema) return <CustomLoader />;
    const { objects, progress, count, selected, userObject } = this.state;

    const fullAddress = [
      userObject?.client?.billingRegion,
      userObject?.client?.billingProvince,
      userObject?.client?.billingCity,
      userObject?.client?.billingBarangay,
      userObject?.client?.billingStreet,
    ]
      .filter(Boolean)
      .join(", ");
    return (
      <>
        <div className="overflow-auto">
          <InfiniteScroll
            className="h-100"
            loadMore={this.loadMore.bind(this)}
            hasMore={!progress && count > objects.length}
          >
            <div className="p-3 p-lg-4">
              <div className="d-flex flex-column gap-4">
                <PageHeader
                  breadcrumb={[
                    { label: "Home", path: "/" },
                    { label: "Clients" },
                  ]}
                  selected={selected}
                  objects={objects}
                  count={count}
                  title={`Clients`}
                  backButton={isAdmin}
                  action={
                    selected.length > 0
                      ? () => (
                          <div className="d-flex gap-2 align-items-center">
                            <button
                              type="button"
                              className="btn bg-success text-white btn-md fw-bold"
                              onClick={() =>
                                this.onSetSelectedStatus("isActive", true)
                              }
                            >
                              <i className="bi bi-check-circle me-1" />
                              Activate
                            </button>
                            <button
                              type="button"
                              className="btn bg-secondary text-white btn-md fw-bold"
                              onClick={() =>
                                this.onSetSelectedStatus("isActive", false)
                              }
                            >
                              <i className="bi bi-x-circle me-1" />
                              Deactivate
                            </button>
                          </div>
                        )
                      : undefined
                  }
                />
                {userObject?.client && (
                  <CardWithHeader
                    title={userObject?.client?.name}
                    description={userObject?.client?.businessType}
                    show={userObject?.client}
                  >
                    <div>
                      <small>{fullAddress || ""}</small>
                    </div>
                  </CardWithHeader>
                )}
                <></>
                {/* Search and Filters Card */}
                <SearchFilterCard
                  schema={schema}
                  schemas={schemas}
                  onSearch={this.searchSubmit.bind(this)}
                  searchFields={{
                    companyName: { type: "String" },
                    contactPerson: { type: "String" },
                  }}
                  onFilter={this.onChangeFilter.bind(this)}
                />

                {/* Table Card */}

                {progress && objects.length === 0 ? (
                  <div
                    className="d-flex justify-content-center align-items-center"
                    style={{ minHeight: "400px", padding: "3rem" }}
                  >
                    <CustomLoader />
                  </div>
                ) : (
                  <div
                    className="rounded-3 shadow-sm"
                    style={{
                      border: "1px solid #e9ecef",
                      overflow: "hidden",
                    }}
                  >
                    <ClientsTable
                      objects={objects}
                      schema={schema}
                      schemas={schemas}
                      selected={selected}
                      progress={progress}
                      selectable
                      onSort={this.onClickSort.bind(this)}
                      onSelect={this.onSelect.bind(this)}
                      onSelectAll={this.onSelectAll.bind(this)}
                      onEdit={this.onEdit.bind(this)}
                      onCollapse={this.onCollapse.bind(this)}
                      onToggleBoolean={this.onToggleBoolean.bind(this)}
                    />
                  </div>
                )}
              </div>
            </div>
            <AddButton onClick={this.onClickAdd.bind(this)} show={true} />
          </InfiniteScroll>
        </div>
      </>
    );
  }
}

export default withRouter(ClientsListPage);
